export default __webpack_public_path__ + "static/media/modulo-kits.bc3d4a65.png";